import 'swiper/css';
import '../scss/app.scss';
import 'leaflet/dist/leaflet.css';
import 'glightbox/dist/css/glightbox.css'
import 'lazysizes';
import 'lazysizes/plugins/bgset/ls.bgset';

import GlobalEvents from '@dubbelspaeth/web-base/packages/globalEvents';
import FormHelper from '@dubbelspaeth/web-base/packages/formHelper';
import BlocksHelper from '@dubbelspaeth/web-base/packages/blocksHelper';
import {default as Header, HeaderPosition} from '@dubbelspaeth/web-base/packages/header';

import Slider from './_slider';

import L from 'leaflet';

import GLightbox from 'glightbox';

BlocksHelper.setOptions({
    rootMargin: '-40% 0% -40% 0%'
});

const selectorToLib: {[key: string]: any} = {
    '.header': function(target: HTMLElement) {
        new Header(target, {
            'position': HeaderPosition.StickyAfterFirst,
            'disableScrollOnMobile': true
        })
    },
    '.swiper': Slider,
    'form': FormHelper,
    '.block': function(target: HTMLElement) {
        BlocksHelper.add(target);
    }
};

for (const selector in selectorToLib) {
    const elements = document.querySelectorAll(selector);
    if (elements) {
        for (let i = 0; i < elements.length; i++) {
            new selectorToLib[selector](elements[i]);
        }
    }
}

GlobalEvents.on('imageLazyloaded', (e) => {
    const parent = e.target.parentElement;
    if (parent.classList.contains('lazy-image')) {
        parent.classList.add('lazy-image--loaded');
    }
});


// Leaflet Map
// check if map element exists and have children
const mapElement = document.getElementById('map');
if (mapElement && mapElement.children.length > 0) {
    interface MarkerData {
        coords: [number, number];
        popupContent: string;
    }

    const customIcon = L.icon({
        iconUrl: '../dist/web/images/content/marker-icon.png',
        iconRetinaUrl: '../dist/web/images/content/marker-icon.png',
        iconSize: [40, 50],
        iconAnchor: [11, 40],
        popupAnchor: [8, -34],
        tooltipAnchor: [16, -28],
    });

    // read marker data from mapElement->marker (every marker is a child of mapElement, have attribute data-coords and popup content is html of marker)

    const markerDataList: MarkerData[] = Array.from(mapElement.children).map((marker) => {
        const coordsAttr = marker.getAttribute('data-coords');
        const popupContent = marker.innerHTML;

        if (!coordsAttr) {
            throw new Error('Marker data-coords attribute is missing');
        }

        const coords = coordsAttr.split(',').map(Number) as [number, number];

        return { coords, popupContent };
    });

    const map = L.map('map', {
        center: [48.1393, 11.5771],
        zoom: 12,
        scrollWheelZoom: false,
        touchZoom: false,
        tap: false
    });

    L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
        attribution: '&copy; OpenStreetMap contributors'
    }).addTo(map);

    const bounds: [number, number][] = [];

    markerDataList.forEach((markerData) => {
        const marker = L.marker(markerData.coords, { icon: customIcon }).addTo(map);
        marker.bindPopup(markerData.popupContent);
        bounds.push(markerData.coords);
    });
    console.log(bounds);
    map.fitBounds(bounds);
} 
// Accordion
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll<HTMLElement>(".accordion-panel").forEach((accordion) => {
        const header = accordion.querySelector<HTMLElement>(".accordion-header");
        const content = accordion.querySelector<HTMLElement>(".accordion-content");
        const icon = accordion.querySelector<SVGElement>(".accordion-icon");

        if (!header || !content || !icon) return;

        header.tabIndex = 0;
        header.setAttribute("aria-expanded", "false");
        content.style.display = "none";

        const toggleAccordion = () => {
            const isOpen = content.style.display === "block";

            document.querySelectorAll(".accordion-panel").forEach((item) => {
                item.querySelector<HTMLElement>(".accordion-content")!.style.display = "none";
                item.querySelector<SVGElement>(".accordion-icon")!.style.transform = "rotate(0deg)";
                const h = item.querySelector<HTMLElement>(".accordion-header")!;
                h.classList.remove("active");
                h.setAttribute("aria-expanded", "false");
            });

            if (!isOpen) {
                content.style.display = "block";
                icon.style.transform = "rotate(180deg)";
                header.classList.add("active");
                header.setAttribute("aria-expanded", "true");
            }
        };

        header.addEventListener("click", toggleAccordion);
        header.addEventListener("keydown", (e) => {
            if (["Enter", " "].includes(e.key)) {
                e.preventDefault();
                toggleAccordion();
            }
        });
    });
});

// FAQ Category switcher in .faq-section
document.addEventListener("DOMContentLoaded", () => {
    const faqSection = document.querySelector('.faq-section');
    if (!faqSection) return;
    const categoryButtons = faqSection.querySelectorAll('.faq-button-list-item');
    const faqPanels = faqSection.querySelectorAll('.faq-accordion-list');
    const faqPanelsArray = Array.from(faqPanels);

    categoryButtons.forEach((button) => {
        button.addEventListener('click', () => {
            const category = button.getAttribute('data-target');
            if (!category) return;

            // Remove active class from all buttons
            categoryButtons.forEach(btn => btn.classList.remove('active'));

            // Add active class to the clicked button
            button.classList.add('active');

            // Hide all panels
            faqPanelsArray.forEach(panel => panel.classList.remove('active'));

            // Show the selected panel
            const selectedPanel = faqSection.querySelector(`${category}`);
            if (selectedPanel) {
                selectedPanel.classList.add('active');
            }
        });
    });
});



//Counter
function animateCounter(element: HTMLElement) {
    const target: number = parseInt(element.getAttribute("data-target") || "0");
    let count: number = 0;
    const increment: number = target / 100;

    function updateCounter() {
        count += increment;
        if (count < target) {
            element.innerText = Math.floor(count).toString();
            requestAnimationFrame(updateCounter);
        } else {
            element.innerText = target.toString();
        }
    }

    updateCounter();
}

document.addEventListener("DOMContentLoaded", () => {
    const uspSection = document.querySelector('.usp-section');
    let hasAnimated = false;

    if (!uspSection) return;

    const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
            if (
                mutation.attributeName === 'class' &&
                uspSection.classList.contains('block--visible') &&
                !hasAnimated
            ) {
                hasAnimated = true;

                document.querySelectorAll(".usp-counter").forEach(counter => {
                    animateCounter(counter as HTMLElement);
                });

                observer.disconnect();
            }
        });
    });

    observer.observe(uspSection, { attributes: true });
});


// Hamburger Menu
const hamburger = document.getElementById("hamburger-menu");
const mobileNav = document.getElementById("mobile-nav");

hamburger.addEventListener("click", () => {
    hamburger.classList.toggle("active");
    mobileNav.classList.toggle("active");
});


//Form Input-Counter
function adjustCounter(change: number): void {
    const input = document.getElementById('form-input-counter') as HTMLInputElement | null;
    if (!input) return;

    let value = parseInt(input.value, 10) || 0;
    value += change;
    if (value < 0) value = 0;
    input.value = value.toString();
}

(window as any).adjustCounter = adjustCounter;


//Lightbox
window.addEventListener('DOMContentLoaded', () => {
    GLightbox({
        selector: '.lightbox'
    });
});

// Desktop navigation
document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".nav-item.dropdown").forEach(item => {
        const icon = item.querySelector<HTMLElement>(".navigation-icon");
        const submenu = item.querySelector<HTMLElement>(".dropdown-menu");
        const navLink = item.querySelector<HTMLElement>(".nav-link");
        if (!icon || !submenu || !navLink) return;

        if (!icon.hasAttribute("tabindex")) icon.tabIndex = 0;

        const setMenu = (open: boolean) => {
            submenu.classList.toggle("open", open);
            icon.classList.toggle("rotated", open);
            icon.setAttribute("aria-expanded", String(open));
            navLink.classList.toggle("active-nav", open);
        };

        icon.onclick = e => { e.preventDefault(); setMenu(!submenu.classList.contains("open")); };
        icon.onkeydown = e => { if (["Enter"," "].includes(e.key)) { e.preventDefault(); setMenu(!submenu.classList.contains("open")); } };
        icon.onfocus = () => navLink.classList.add("active-nav");
        item.addEventListener("focusout", e => {
            const rt = (e as FocusEvent).relatedTarget as HTMLElement | null;
            if (!rt || !item.contains(rt)) {
                setMenu(false);
                navLink.classList.remove("active-nav");
            }
        });
    });
});

// Mobile Navigation
document.querySelectorAll<HTMLElement>('.nav-item.dropdown').forEach(item => {
    const icon = item.querySelector<HTMLElement>('.navigation-icon');
    const submenu = item.nextElementSibling as HTMLElement;

    if (!icon || !submenu || !submenu.classList.contains('dropdown-menu')) return;

    icon.addEventListener('click', e => {
        e.preventDefault();
        const open = submenu.hidden;

        document.querySelectorAll<HTMLElement>('.dropdown-menu').forEach(m => m.hidden = true);
        document.querySelectorAll('.navigation-icon').forEach(i => i.classList.remove('rotated'));
        document.querySelectorAll('.nav-item.dropdown').forEach(i => {
            i.setAttribute('aria-expanded', 'false');
            (i as HTMLElement).style.backgroundColor = '';
        });

        if (open) {
            submenu.hidden = false;
            item.setAttribute('aria-expanded', 'true');
            item.style.backgroundColor = '#F16048';
            icon.classList.add('rotated');
        }
    });
});
